import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/master-type/`;

class cdoMasterType {
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    selectAll = (callback) => {
        util.getJSON(servicesURL + 'select-all', callback);
    }

    select = (data, callback) => {
        util.putJSON(servicesURL + 'select', data, callback);
    }
}

const cdo = new cdoMasterType();
export default cdo;
